export const depositSlipsRoutes = [
  {
    path: '/deposit-slips/listing',
    name: 'deposit-slips',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "deposit-slips" */ './DepositSlips.vue')
  }
];
